// extracted by mini-css-extract-plugin
export default {"actions":"Alumnos_actions__6zUV9","download":"Alumnos_download__SawxL","link":"Alumnos_link__+MQ4+"};